module.exports = __webpack_public_path__ + "static/media/icone-download-image-branco.eac0fc2f.svg";